import React, {Fragment} from "react";
import { useSelector } from "react-redux";
import logo from "../../../assets/img/logo.png"
import Profile from "../dashboardComponents/Profile"
import CreateExam from "./AdComponents/CreateExam";
import { useUserActions } from "../../../hooks/user.actions";

function ProducerDashboard({user}){
    const [isShown, setIsShown] = React.useState(false)
    const [selectedItem, setSelectedItem] = React.useState("Post New Beats")

    const useActions = useUserActions()

    function Toogle(){
        setIsShown( prevState => !prevState )
    }

    return(
        <Fragment>
            <div className="logo-container">

                <img src={logo} alt="logo" className="Dashboard--logo"/>

                <div className="topbar--Menu">
                    <ul>
                        <li><i className="fa-solid fa-circle-info"></i>About us</li>
                        <hr></hr>
                        <li onClick={Toogle}>Menu<i className="fa-solid fa-caret-down"></i></li>
                    </ul>

                </div>

                <ul className={`menu ${isShown &&"shown"}`}>
                    <li className="menu--item" onClick={() => setSelectedItem("Profile")}><i className="fa-solid fa-house" id="menu--icons" ></i><span>Profile</span></li>
                    <li className="menu--item" onClick={() => setSelectedItem("Post New Beats")}><i className="fa-solid fa-clipboard" id="menu--icons" ></i><span>Post New Beats</span></li>
                    <li className="menu--item" onClick={() => useActions.logout()}><i className="fa-solid fa-right-from-bracket" id="menu--icons" ></i><span>Logout</span></li>
                </ul>

                
            </div>

            <div className="dashboard">

                {selectedItem === "Profile" &&  <Profile user={user}/>}

                {selectedItem === "Post New Beats" && <CreateExam user={user}/>}

                
            </div>

        </Fragment>
    )

}

export default ProducerDashboard;